import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';

export function PricingPage() {
  return (
    <div className="overflow-hidden">
      {/* Hero */}
      <section className="section-padding bg-slate-50 dark:bg-obsidian">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-black text-obsidian dark:text-signal leading-tight">
              Choose how you want to work with us
            </h1>
            <p className="mt-6 text-lg text-slate-600 dark:text-slate-400 leading-relaxed">
              Build your retention system yourself with the tool, or work directly with us for a custom engagement.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing cards */}
      <section className="section-padding bg-white dark:bg-obsidian border-t border-slate-200 dark:border-slate-800">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Retention Builder */}
            <Card variant="bordered" padding="lg" className="border-amber">
              <CardContent>
                <span className="text-xs font-semibold text-amber uppercase tracking-wider">
                  Self-service
                </span>
                <h2 className="mt-2 text-2xl font-heading font-black text-obsidian dark:text-signal">
                  Retention Builder
                </h2>
                <p className="mt-4 text-4xl font-heading font-black text-obsidian dark:text-signal">
                  $49<span className="text-lg text-slate-500">/month</span>
                </p>

                <div className="mt-8 space-y-4">
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">All five modules: signals, risk, playbooks, metrics, renewal</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">AI-guided conversation tailored to your business</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">Exportable retention system document</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">Access to all future modules and updates</span>
                  </div>
                </div>

                <div className="mt-8">
                  <a href="https://app.churnlogix.com">
                    <Button variant="primary" className="w-full" rightIcon={<ArrowRight className="w-5 h-5" />}>
                      Start building
                    </Button>
                  </a>
                </div>
              </CardContent>
            </Card>

            {/* Diagnostic Engagement */}
            <Card variant="bordered" padding="lg">
              <CardContent>
                <span className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                  Full service
                </span>
                <h2 className="mt-2 text-2xl font-heading font-black text-obsidian dark:text-signal">
                  Diagnostic Engagement
                </h2>
                <p className="mt-4 text-4xl font-heading font-black text-obsidian dark:text-signal">
                  Let's talk
                </p>

                <div className="mt-8 space-y-4">
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">Full churn diagnostic for your business</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">Specific recommendations matched to your situation</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">Implementation of process changes and systems</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">Data products where warranted</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-amber flex-shrink-0 mt-0.5" />
                    <span className="text-slate-600 dark:text-slate-400">Ongoing support through implementation</span>
                  </div>
                </div>

                <div className="mt-8">
                  <Link to="/contact">
                    <Button variant="outline" className="w-full" rightIcon={<ArrowRight className="w-5 h-5" />}>
                      Book a diagnostic
                    </Button>
                  </Link>
                </div>
              </CardContent>
            </Card>
          </div>

          <p className="mt-12 text-center text-slate-500">
            Not sure which is right for you? The builder is where most operators start.
          </p>
        </div>
      </section>
    </div>
  );
}

export default PricingPage;
